import { BrowserRouter as Router, Route, Switch, } from 'react-router-dom';
import LandingPage from './Components/NewPortfolio';
import MyProjects from './Components/MyProjects';
import Wops from './Components/Wops';
import Chips from './Components/Chips';
import Sunscreen from './Components/Sunscreen';
import Elizabeth from './Components/Elizabeth';
import Petvouge from './Components/Petvouge';
import Seguro from './Components/Seguro';
import Blender from './Components/3d';
import Contact from './Components/Contact';
import About from './Components/About';
import Heyboost from './Components/heyboost';


function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={LandingPage} />
        <Route path="/allprojects" component={MyProjects} />
        <Route path="/wops" component={Wops} />
        <Route path="/gif" component={Chips} />
        <Route path="/july" component={Sunscreen} />
        <Route path="/eml" component={Elizabeth} />
        <Route path="/pet" component={Petvouge} />
        <Route path="/seguro" component={Seguro} />
        <Route path="/3d" component={Blender}/>
        <Route path="/contact" component={Contact}/>
        <Route path="/about" component={About}/>
        <Route path="/heyboost" component={Heyboost}/>
      </Switch>
    </Router>
  );
}

export default App;
